export enum LearningAnswerSpeech {
  always,
  onlyIncorrect,
  none,
}
